import { Moment } from 'moment'
import { useState } from 'react'

import {
  FilterWashingCountByDay,
  TotalWashingCountByRangeDayTable,
} from '@/components/pages/WashingCount/WashingCountByDay'
import ClientWashingCountHeader from '@/components/pages/WashingCount/WashingCountByDay/PageHeader'
import WashingCountByDayTable from '@/components/pages/WashingCount/WashingCountByDay/Table'
import WashingCountByRangeDayTable from '@/components/pages/WashingCount/WashingCountByDay/TableWashingCountByRangeDay'
import { DateType } from '@/types'

import { useWashingCountByDay } from './WashingCountByDay.hooks'

export type FilterDate = {
  type: DateType
  fromDate: Moment | null
  toDate: Moment | null
  totalFromDate: Moment | null
  totalToDate: Moment | null
}

export const defaultFilterDate: FilterDate = {
  type: DateType.NO_SELECT,
  fromDate: null,
  toDate: null,
  totalFromDate: null,
  totalToDate: null,
}

const WashingCountByDay = () => {
  const {
    getWashingCountByDay,
    getWashingCountByRangeDay,
    getTotalWashingByRangeDay,
    exportExcelWashingCountByDay,
    exportExcelByRangeDay,
    exportExcelTotalWashingByRangeDay,
    responseWashingCount,
    responseWashingCountLoading,
    responseWashingCountByRangeDay,
    responseWashingCountByRangeDayLoading,
    exportWashingCountLoading,
    exportWashingCountByDayLoading,
    responseTotalWashingCount,
    responseTotalWashingCountLoading,
  } = useWashingCountByDay()

  const [dateFilter, setDateFilter] = useState<Moment | null>()
  const [dateRangeFilter, setDateRangeFilter] = useState<FilterDate>(defaultFilterDate)

  return (
    <>
      <ClientWashingCountHeader />
      <FilterWashingCountByDay
        getWashingCountByDay={getWashingCountByDay}
        exportExcelWashingCountByDay={exportExcelWashingCountByDay}
        getWashingCountByRangeDay={getWashingCountByRangeDay}
        getTotalWashingCountByRangeDay={getTotalWashingByRangeDay}
        exportExcelWashingCountByRangeDay={exportExcelByRangeDay}
        setDateFilter={setDateFilter}
        dateFilter={dateFilter}
        setDateRangeFilter={setDateRangeFilter}
        dateRangeFilter={dateRangeFilter}
        exportWashingCountLoading={exportWashingCountLoading}
        exportWashingCountByDayLoading={exportWashingCountByDayLoading}
        exportWashingCountByRangeDayLoading={responseWashingCountByRangeDayLoading}
        exportExcelTotalWashingCountByRangeDay={exportExcelTotalWashingByRangeDay}
      />
      {dateFilter && (
        <WashingCountByDayTable
          responseWashingCount={responseWashingCount}
          responseWashingCountLoading={responseWashingCountLoading}
          dateFilter={dateFilter}
        />
      )}

      {responseWashingCountByRangeDay && dateRangeFilter.fromDate && dateRangeFilter.toDate && (
        <WashingCountByRangeDayTable
          responseWashingCountByRangeDay={responseWashingCountByRangeDay}
          responseWashingCountByRangeDayLoading={responseWashingCountByRangeDayLoading}
        />
      )}

      {responseTotalWashingCount && dateRangeFilter.totalFromDate && dateRangeFilter.totalToDate && (
        <TotalWashingCountByRangeDayTable
          responseTotalWashingCount={responseTotalWashingCount}
          responseTotalWashingCountLoading={responseTotalWashingCountLoading}
        />
      )}
    </>
  )
}

WashingCountByDay.displayName = 'WashingCountByDay'
export default WashingCountByDay
